module.exports = __webpack_public_path__ + "static/media/bg.813f4105.svg";